import React, { useEffect, useState } from "react";
import {
  Row,
  Col,
  Card,
  Form,
  InputGroup,
  Modal,
  Button,
  Table,
  Badge,
} from "react-bootstrap";
import { Link, useParams, useNavigate } from "react-router-dom";

import { testmenuGetAgency, testmenuUpdateAgency } from "../../api/testMenuService";

function MyPage() {
  const { id } = useParams();
  const navigate = useNavigate();

  const [agencyDetails, setAgencyDetails] = useState({
    agencyName: "",
    phoneNumber: "",
  });

  useEffect(() => {
    if (id) {
      fetchAgencyDetails();
    }
  }, [id]);

  const fetchAgencyDetails = async () => {
    try {
      const result = await testmenuGetAgency(id);
      setAgencyDetails(result);
    } catch (error) {
      console.error("Error fetching agency detail:", error);
    }
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setAgencyDetails((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
        await testmenuUpdateAgency(id, agencyDetails);
        alert("Agency updated successfully");
      navigate("/testmenu/list");
    } catch (error) {
      alert("Error Update agency");
    }
  };

  return (
    <Card className="mt-4">
      <Card.Body>
        <Form onSubmit={handleSubmit}>
          <Row className="mb-3">
            <Col sm={6}>
              <Form.Label>
                <strong>AGENCY NAME</strong>
              </Form.Label>
              <Form.Control
                type="text"
                name="agencyName"
                value={agencyDetails.agencyName}
                onChange={handleChange}
                required
              />
            </Col>
            <Col sm={6}>
              <Form.Label>
                <strong>AGENCY PHONE NUMBER</strong>
              </Form.Label>
              <Form.Control
                type="text"
                name="phoneNumber"
                value={agencyDetails.phoneNumber}
                onChange={handleChange}
                required
              />
            </Col>
          </Row>
            <Button type="submit" variant="primary">
              Update
            </Button>
        </Form>
      </Card.Body>
    </Card>
  );
}

export default MyPage;
